<template>
  <div>Verificando</div>
</template>

<script>
export default {
  methods: {
  },
  mounted() {
    this.token = this.$route.params.token;
    const form = new FormData();
    form.append("token", this.token);

    this.$http
      .post(this.$store.state.url + "/api/verification", form)
      .then( () => {
        this.$router.push("/home");
      })
      .catch(error => {
        this.$router.push("/home");

        if (error.response.status == 401) {
          this.$buefy.dialog.alert({
            title: "Hubo un error en la conexión",
            message: "No se pudo verificar.",
            type: "is-warning",
            hasIcon: true,
            icon: "alert-octagon"
          });
        } else {
          alert("Error al ingresar");
        }
      });
  },
  data() {
    return {
      token: null
    };
  }
};
</script>
